const Fuse = require('fuse.js');
const BASE_URL = '/api/collections/consulting/entries';

export default () => ({
  searchQuery: '',
  consultingItems: [],
  filteredConsultingItems: [],

  filterConsulting() {
    if (!this.searchQuery) {
      return (this.filteredConsultingItems = this.consultingItems);
    }

    const fuse = new Fuse(this.consultingItems, {
      isCaseSensitive: false,
      keys: ['description_short', 'title'],
    });

    this.filteredConsultingItems = fuse
      .search(this.searchQuery)
      .map((searchResultItem) => searchResultItem.item);
  },

  resetFilter() {
    this.searchQuery = '';
    this.filteredConsultingItems = this.consultingItems;
  },

  fetchConsulting() {
    fetch(`${BASE_URL}?sort=title`)
      .then((response) => response.json())
      .then((response) => {
        this.consultingItems = [...response.data];
        this.filteredConsultingItems = this.consultingItems;
      });
  },

  handleConsultingListCheckboxes(event) {
    const checkbox = event.target;
    const parentWrapper = checkbox.closest('.consulting-form__checkboxes');
    const textarea = parentWrapper.querySelector('#consulting-list');
    const checkboxes = parentWrapper.querySelectorAll('input[type="checkbox"]');

    const checkedValues = Array.from(checkboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    textarea.value = checkedValues.join(';');
  },

  init() {
    this.fetchConsulting();
  },
});
